export enum PaymentMethods {
  NotIdentified = "",
  Credit = "Crédito",
  Debit = "Débito",
  Pix = "Pix",
}
